module.exports = __webpack_public_path__ + "img/action-black.b1cb8706.svg";